export const CALCULATIONS = 'md_calculations_GLOBAL';